var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconTermConditionsSoyYoBank = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 23.5,
    fill: "#9BE0F1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 23.5,
    stroke: "#59CBE8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_116_7248)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6654 15.9993C18.6654 13.7327 20.3987 11.9993 22.6654 11.9993C24.932 11.9993 26.6654 13.7327 26.6654 15.9993V17.9993C26.6654 19.9993 25.732 23.9993 22.6654 23.9993C19.5987 23.9993 18.6654 19.9993 18.6654 17.9993V15.9993ZM17.332 17.9993C17.332 21.066 18.932 25.3327 22.6654 25.3327C26.3987 25.3327 27.9987 21.066 27.9987 17.9993V15.9993C27.9987 13.066 25.5987 10.666 22.6654 10.666C19.732 10.666 17.332 13.066 17.332 15.9993V17.9993Z",
    fill: "#2C2A29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.866 26.6659C16.666 27.9992 18.666 30.2659 22.666 30.2659C23.866 30.2659 24.9327 29.9992 25.9994 29.5992V33.1992H11.9993V31.1992C11.9993 28.9326 13.7327 27.0659 15.866 26.6659ZM16.666 25.1992C13.3327 25.1992 10.666 27.8659 10.666 31.1992V34.5326H27.3327V27.1992C26.9327 27.4659 26.5327 27.8659 25.9994 28.1326C25.066 28.5326 23.9994 28.9326 22.666 28.9326C17.9993 28.9326 16.666 25.1992 16.666 25.1992Z",
    fill: "#2C2A29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7333 21.8652L26 25.5986V36.5319H34.9333C36.2667 36.5319 37.3333 35.4652 37.3333 34.1319V21.8652H29.7333ZM36 34.2652C36 34.7986 35.4667 35.3319 34.9333 35.3319H27.3333V26.2652L30.2667 23.3319H36V34.2652Z",
    fill: "#2C2A29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.666 31.8652H28.666V33.1986H34.666V31.8652Z",
    fill: "#2C2A29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.666 29.1992H28.666V30.5326H34.666V29.1992Z",
    fill: "#2C2A29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6667 26.5332H30V27.8665H34.6667V26.5332Z",
    fill: "#2C2A29"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_116_7248"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.6667,
    height: 25.8667,
    fill: "white",
    transform: "translate(10.666 10.666)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconTermConditionsSoyYoBank);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/IconTermConditionsSoyYoBank.30bbadd77c4ac24f98e08a450370cd05.svg";